import { projectManagementApi } from '@/includes/projectManagementApi';
import * as XLSX from 'xlsx';

const SHEET_DEFS = [
  { key: 'project', name: 'Project', asRows: (payload) => [payload.project] },
  { key: 'milestones', name: 'Milestones' },
  { key: 'commitments', name: 'Commitments' },
  { key: 'causes', name: 'Causes' },
  { key: 'constraints', name: 'Constraints' },
  { key: 'decisions', name: 'Decisions' },
  { key: 'decisionHistory', name: 'DecisionHistory' },
  { key: 'kpis', name: 'KPIs' },
  { key: 'kpiHistory', name: 'KPIHistory' },
  { key: 'forecast', name: 'Forecast' },
  { key: 'commitmentQuality', name: 'CommitmentQuality' },
  { key: 'impact', name: 'Impact' },
];

function sheetRows(payload, def) {
  if (typeof def.asRows === 'function') return def.asRows(payload);
  return payload[def.key] || [];
}

function buildWorkbook(payload) {
  const workbook = XLSX.utils.book_new();
  SHEET_DEFS.forEach((def) => {
    const rows = sheetRows(payload, def);
    const worksheet = rows.length
      ? XLSX.utils.json_to_sheet(rows)
      : XLSX.utils.aoa_to_sheet([['(no data)']]);
    XLSX.utils.book_append_sheet(workbook, worksheet, def.name.slice(0, 31));
  });
  return workbook;
}

const pmProjectExportService = {
  async downloadProjectExcel(projectId, projectName = 'project') {
    const response = await projectManagementApi.get(`/projects/${projectId}/export/data`);
    const payload = response.data;
    const workbook = buildWorkbook(payload);
    const safeName = String(projectName || projectId).replace(/[^a-zA-Z0-9-_]+/g, '-').slice(0, 40);
    XLSX.writeFile(workbook, `project-export-${safeName}.xlsx`);
    return payload;
  },
};

export default pmProjectExportService;
